
import React, { useState, useEffect, useContext, FunctionComponent, useRef } from 'react';
import { Label } from '@progress/kendo-react-labels';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { Checkbox, CheckboxChangeEvent } from '@progress/kendo-react-inputs';
import { Input, InputChangeEvent } from '@progress/kendo-react-inputs';
import { Button } from '@progress/kendo-react-buttons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faEnvelope, faAddressCard, faInfoCircle, faQuestionCircle} from '@fortawesome/free-solid-svg-icons';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { atolUser, rollUpGroup, rollUpMember, SiteEntry, userAssociation } from '../services/interfaces';
import parse from 'html-react-parser';
import { PageContext } from './PageContext';
import { getSiteList, saveUser, getUserRollUpGroups } from '../services/apiService';
import { RollUpGroupList, SiteList } from './FormComponents';
import { Col, Row } from 'reactstrap';
import { TabStrip, TabStripSelectEventArguments, TabStripTab } from '@progress/kendo-react-layout';
import { Grid, GridCellProps, GridCellsSettings, GridColumn, GridCustomCellProps, GridSelectionChangeEvent, GridToolbar } from '@progress/kendo-react-grid';
import { getAssociationsForUser, addUserAssociation, removeUserAssociation, addUserGroup, removeUserGroup, deleteUser } from '../services/apiAdminService';
import { SelectDescriptor } from '@progress/kendo-react-data-tools';
import { ConfirmDialog } from './ConfirmDialog';
import { Notification } from '@progress/kendo-react-notification';
import { ChangePassword } from './ChangePassword';
import { trustUser,unTrustUser } from '../services/apiAdminService';
import { Loader } from '@progress/kendo-react-indicators';
// Add this type definition for SelectDescriptor

interface UserProfileProps {
    userProfile:atolUser;
    hideContactInfo: () => void;
    type: string;
    action:string;
    title: string;
}
interface userType{
    text:string
    value:string
}

export default function UserProfileForm({userProfile, hideContactInfo, type, title, action}:UserProfileProps){
    const pageContext=useContext(PageContext);
    const [origUserName, setOrigUserName]=useState("")
    const [userType, setUserType]=useState<userType>()
    const [userSites, setUserSites]=useState<SiteEntry[]>([])
    const [tabSelected, setSelectedTab]=useState(0);
    const [verifyPassword, setVerifyPassword]=useState("")
    const [associations,setAssociations]=useState([]);
    const [groups,setGroups]=useState([]);
    const [idToAssociate,setIdToAssociate]=useState("");
    const [showConfirm, setShowConfirm]=useState(false);
    const [showConfirmGroup, setShowConfirmGroup]=useState(false);
    const [showNotify,setShowNotify]=useState(false);
    const [showDeleteUser,setShowDeleteUser]=useState(false);
    const [showChangePW,setShowChangePW]=useState(false);
    const [userSiteList,setUserSiteList]=useState("");
    const [intAction, setIntAction]=useState("");
    const [loaderVisible,setLoaderVisible]=useState(false);
    const dlgTitle = useRef(""); 
    const [user, setUser]=useState<atolUser>({
        fullName:"",
        customer:"",
        email:"",
        phone:"",
        fax:"",
        userName:"",
        password:"",
        rep_id:0,
        security:0,
        temp1:"",
        temp2:"",
        temp3:"",
        temp4:"",
        temp5:"",
        temp6:"",
        temp7:"",
        salt:0,
        apiKey:"",
        proof_email:false,
        insert_email:false,
        submit_email:false,
        correction_email:false,
        approval_email:false,
        associations:"",
        trusted:0,
        superUser:false
    });

    const [emailOpt, setEmailOpt]=useState({ text: "Do not send any automatic emails", value: "0" })
    const initUser= async (Profile:atolUser)=>{
        if (Profile.approval_email==null){
            Profile.approval_email=false;
        }
        if (Profile.correction_email==null){
            Profile.correction_email=false;
        }
        if (Profile.insert_email==null){
            Profile.insert_email=false;
        }
        if (Profile.proof_email==null){
            Profile.proof_email=false;
        }
        if (Profile.submit_email==null){
            Profile.submit_email=false;
        }
        if (Profile.associations==null){
            Profile.associations="";
        }
        setUser(Profile);
    }

    const getUserType=(security:number)=>{
        console.log (user.security);
        //var security:number=user.security;
        userTypes.map(function (item:userType){
            if (Number(item.value)==security){
                setUserType(item);
            }
        });
    }

    const getUserSites=(siteList:string)=>{
        var userSites:String[]=siteList.split(",");
        console.log(userSites);
        var selSites:SiteEntry[]=[];
        
        getSiteList().then(data => {
            data.map(function(item:SiteEntry){
                 if (userSites.find(siteCode => siteCode === item.code)){
                       console.log(item); 
                       selSites.push(item);                   
                 }
            });
            setUserSites(selSites);
        });
        console.log(siteList);
        //setUser({ ...user, temp4: userSites.toString()})
    }


    const userTypeChange =(e:DropDownListChangeEvent)=>{
        setUserType(e.value);
    }

    const setUserSecurity =(security:number)=>{
        setUser({ ...user, security: security || 0 })

    }

    const setUserName=(e:InputChangeEvent)=>{
        setUser({...user, userName: (e.target.value as string) || ''})
    }

    const setFullName=(e:InputChangeEvent)=>{
        setUser({...user, fullName: (e.target.value as string) || ''})
    }

    const setEmail=(e: InputChangeEvent)=>{
        setUser({...user, email: (e.target.value as string) || ''})
    }

    const setAccount=(e: InputChangeEvent)=>{
        setUser({...user, temp2: (e.target.value as string) || ''})
    }

    const setRepID=(e: InputChangeEvent)=>{
        setUser({...user, customer: (e.target.value as string) || ''})
    }

    const setPhone=(e: InputChangeEvent)=>{
        setUser({...user, phone: (e.target.value as string) || ''})
    }

    const setFax=(e: InputChangeEvent)=>{
        setUser({...user, fax: (e.target.value as string) || ''})
    }

    const setPassword=(e: InputChangeEvent)=>{
        setUser({...user, password: (e.target.value as string) || ''})
    }

    const setConfirmPassword=(e: InputChangeEvent)=>{
        const vpw = e.target.value;
        setVerifyPassword(vpw as string);
    }


    const setEmailPref=(e: DropDownListChangeEvent)=>{
        setEmailOpt(e.value);
        setUser({...user, rep_id: e.value.value})
    }

    const setSiteCodes=(site: SiteEntry[])=>{        
        console.log(site);
        setUserSiteList(site.join(","));
        setUser({ ...user, temp4: site.join(",")})

        //getUserSites(siteList);
        //setUserSites(site);
        
    }

    const setTrustedUser=(e:CheckboxChangeEvent)=>{
        if (e.value){
            //Trust this user
            setUser({...user, trusted: 1})
            switch (user.security){
                case 0:
                    trustUser(user.temp2,user.security.toString());
                    break;
                case 1:
                case 2:
                case 4:
                    trustUser(user.userName,user.security.toString());
                    break;
            }
        }else{
            //untrust this user
            setUser({...user, trusted: 0})
            switch (user.security){
                case 0:
                    unTrustUser(user.temp2);
                    break;
                case 1:
                case 2:
                case 4:
                    unTrustUser(user.userName);
                    break;
            }
        }
    }

    const setTrafficUser=(e:CheckboxChangeEvent)=>{
        if (e.value){
            setUser({...user, temp3: "traffic"})
        }else{
            setUser({...user, temp3: ""})
        }
    }

    const getAssociations=(username:string)=>{
        
        getAssociationsForUser(username).then(data=>{
            setAssociations(data);
        });

    }

    const getGroups=(username:string)=>{
        getUserRollUpGroups(username).then(data=>{
            setGroups(data);
        });
    }

    const updateIdToAssociate=(e:InputChangeEvent)=>{
        setIdToAssociate(e.value);
    }

    const makePrimary=(e:CheckboxChangeEvent)=>{
        if (e.value==true){
            setIsPrimary(true);
        }else
        {
            setIsPrimary(false);
        }
    }


    const [assocValid,setAssocValid]=useState(true);
    const [groupValid,setGroupValid]=useState(true);
    const [isPrimary,setIsPrimary]=useState(false);
    const addAssociation=()=>{
        if (idToAssociate!=""){
            setAssocValid(true);
            const newAssoc:userAssociation={
                username:user.userName,
                association:idToAssociate,
                security:user.security.toString(),
                expires:"99999999"
            }
            addUserAssociation(newAssoc).then(()=>{
                getAssociations(user.userName);
                setIdToAssociate("");
            });
        }else{
            setAssocValid(false);
        }
    }

    const removeAssociation=()=>{
        console.log(Object.keys(assocSelect)[0]);
        const association = Object.keys(assocSelect)[0];
        const newAssoc:userAssociation={
            username:user.userName,
            association:association,
            security:user.security.toString(),
            expires:"99999999"
        }
        hideConfirm();
        removeUserAssociation(newAssoc).then(()=>{
            getAssociations(user.userName);
            setIdToAssociate("");
        });
    }

    const addGroup=()=>{
        if (newGroup.groupId!=""){
            setGroupValid(true);
            const newRGroup:rollUpMember={
                username:user.userName,
                groupId:newGroup.groupId,
                primary:isPrimary
            }
            addUserGroup(newRGroup).then(()=>{
                getGroups(user.userName);
                setIsPrimary(false);
                setNewGroup({
                    groupId:"",
                    groupName:"Select Group",
                    primary:false
                });
            });
        }
    }
    const [groupSelect, setGroupSelect] = React.useState<SelectDescriptor>({});

    const removeGroup=()=>{

        console.log(Object.keys(groupSelect)[0]);
        const group = Object.keys(groupSelect)[0];
        const newRGroup:rollUpMember={
                 username:user.userName,
                 groupId:group,
                 primary:false
            }
            hideConfirmGroup();
            removeUserGroup(newRGroup).then(()=>{
                getGroups(user.userName);
            });
    }

    const formatUserType: FunctionComponent<GridCustomCellProps> = (props) => {
        let typeLabel = "";
        switch (props.dataItem.security) {
            case 0:
                typeLabel = "Agency";
                break;
            case 1:
                typeLabel = "Sales ID";
                break;
            case 2:
                typeLabel = "Sales Assistant";
                break;
            case 3:
                typeLabel = "Customer Account";
                break;
            case 4:
                typeLabel = "Sales ID";
                break;
            default:
                typeLabel = "Unknown";
        }
        return <td>{typeLabel}</td>;
    }

    const getEmailPref=(type:number)=>{
        switch (type){
            case 0:
                setEmailOpt({ text: "Do not send any automatic emails", value: "0" });
                break;
            case 1:
                setEmailOpt({ text: "Send all emails automatically", value: "1" });
                break;
            case 9:
                setEmailOpt({ text: "Only send proof emails automatically", value: "9" });
                break;
            case 8:
                setEmailOpt({ text: "Only send material request emails automatically", value: "8" });
                break;                            
        }
    }

    const getTrustedUser=()=>{
        if (user.trusted===1){
           return true 
        }else{
            return false
        }
    }

    const getTrafficUser=()=>{
        if (user.temp3==="traffic"){
           return true 
        }else{
            return false
        }
    }

    const callSaveUser=()=>{
        console.log(user);
        showLoader();
        saveUser(user,type).then(()=>{
            if (intAction=="New"){
                setIntAction("Edit")
            }
            if (user.security===1 || user.security===2|| user.security===4){
                //Add user association for reps assistants and managers
                const newAssoc:userAssociation={
                    username:user.userName,
                    association:user.customer,
                    security:user.security.toString(),
                    expires:"99999999"
                }
                addUserAssociation(newAssoc).then(()=>{
                    getAssociations(user.userName);
                    setIdToAssociate("");
                });
            }
            setNotifyMsg("User saved");
            setNotifyType({style:"success",icon:true})
            setShowNotify(true);
            setTimeout(()=>{
                setShowNotify(false);   
            },30000)
            hideLoader();
            //hideContactInfo();
        });
    }

    const userTypes:userType[]=[
        { text: "All users", value: "All" },
        { text: "Customer", value: "0" },
        { text: "Sales Rep", value: "1" },
        { text: "Sales Asst", value: "2" },
        { text: "Agency", value: "3" },
        { text: "Customer Service", value: "3C" },
        { text: "Manager", value: "4" },
        { text: "Administrator", value: "5" },
        { text: "DTO", value: "9" },
        { text: "Designer", value: "20" },
        { text: "MediaMagic", value: "40" },
        { text: "MediaMagic Admin", value: "41" }
    ]

    const handleTabSelect = (e: TabStripSelectEventArguments) => {
        setSelectedTab(e.selected);
    }

    const [assocSelect, setAssocSelect] = React.useState<SelectDescriptor>({});

    const onAssocSelectionChange = React.useCallback((event: GridSelectionChangeEvent) => {
        setAssocSelect(event.select);
        console.log(event.select);
    }, []);

    const [newGroup,setNewGroup]=useState<rollUpGroup>({
        groupId:"",
        groupName:"",
        primary:false
    });


    const onGroupSelectionChange = React.useCallback((event: GridSelectionChangeEvent) => {
        setGroupSelect(event.select);
        console.log(event.select);
    }, []);

    const onNewGroupChange=(group:rollUpGroup)=>{
        console.log(group);
        setNewGroup(group);
    }

    const showLoader=()=>{
        setLoaderVisible(true);
    }

    const hideLoader=()=>{
        setLoaderVisible(false);
    }


    const viewConfirmAssoc=()=>{
        if (Object.keys(assocSelect)[0]){
            setShowConfirm(true);
            setShowNotify(false);
        }else{
            console.log("No Selection")
            setNotifyMsg("You must select from the list below");
            setNotifyType({style:"error",icon:true})
            setShowNotify(true);
        }
    }

    const viewConfirmGroup=()=>{
        if (Object.keys(groupSelect)[0]){
            setShowConfirmGroup(true);
            setShowNotify(false);
        }else{
            console.log("No Selection")
            setNotifyMsg("You must select from the list below");
            setNotifyType({style:"error",icon:true})
            setShowNotify(true);
        }
    }

    const hideConfirm=()=>{
        setShowConfirm(false);
    }

    const hideConfirmGroup=()=>{
        setShowConfirmGroup(false);
    }

    const openChangePassword=()=>{
        setShowChangePW(true);
    }

    const closeChangePassword=()=>{
        setShowChangePW(false);
    }

    const hideDelete=()=>{
        setShowDeleteUser(false);
    }

    const callShowDelete=()=>{
        setShowDeleteUser(true);
    }

    const callDeleteUser=()=>{
        console.log("Delete User");
        console.log(userProfile);
        deleteUser(userProfile.userName).then(data=>{
            hideContactInfo();
        });
    }

    const [notifyMsg, setNotifyMsg]=useState("");
    const [NotifyType, setNotifyType]=useState<{style?: "error" | "info" | "warning" | "none" | "success"; icon?: boolean}>({style:"error",icon:true});

    useEffect(()=>{
        setUserSecurity(Number(userType?.value) || 0);
    },[userType])

    useEffect(()=>{
       console.log(userSites);
    
    },[userSites])

    useEffect(()=>{
        if (userSiteList!=""){
            getUserSites(userSiteList);
        }        
    },[userSiteList])

    useEffect(()=>{
        if (action=="New"){
            dlgTitle.current="New User";
        }else{
            dlgTitle.current="User Profile: " + user.userName;
        }
    },[intAction]);

    useEffect(()=>{
        console.log(userProfile);
        setIntAction(action);
        setOrigUserName(userProfile.userName);
        initUser(userProfile);
        getUserType(userProfile.security);
        setUserSiteList(userProfile.temp4);
        getAssociations(userProfile.userName);
        getGroups(userProfile.userName);
        getEmailPref(userProfile.rep_id);
    },[])

    return(
        <Dialog title={dlgTitle.current} onClose={hideContactInfo} width={700} height={"90vh"}>
            {type!="Admin"?
                <div className="rounded bg-primary text-white p-3 mb-3">
                    <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon>&nbsp;<span id="exPromptMessage">{parse(pageContext?.docLinkSet.Links.find(link=>link.Placeholder==="EditCustomer")?.Prompt||"")}</span><span className="float-end"><a target="_blank" id="exHelpLink" style={{color:"white!important"}} className='whitelink' href={pageContext?.docLinkSet.Links.find(link=>link.Placeholder==="EditCustomer")?.Url}><FontAwesomeIcon icon={faQuestionCircle}></FontAwesomeIcon>&nbsp;Learn More</a></span>
                </div>
            :
                intAction=="New"
                    ? <div className="rounded bg-primary text-white p-3 mb-3">
                        <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon>&nbsp;<span id="exPromptMessage">Access to additional settings will become available after saving the new user.</span><span className="float-end"></span>
                    </div>
                    : null
            }
            {showDeleteUser?<ConfirmDialog title='Delete selected user?' message='Are you sure you want to continue? This action cannot be undone.' type='WARN' onClose={hideDelete} onConfirm={callDeleteUser} confirmButtonText='Yes' cancelButtonText='No'></ConfirmDialog>:null}
            {showConfirm?<ConfirmDialog title='Remove association?' message='Are you sure you want to continue?' type='WARN' onClose={hideConfirm} onConfirm={removeAssociation} confirmButtonText='Yes' cancelButtonText='No'></ConfirmDialog>:null}
            {showConfirmGroup?<ConfirmDialog title="Remove Group" message="Are you sure you want to continue?" type="WARN" onClose={hideConfirmGroup} onConfirm={removeGroup} confirmButtonText='Yes' cancelButtonText='No'></ConfirmDialog>:null}
            {showNotify?<Notification type={NotifyType}>{notifyMsg}</Notification>:null}
            {showChangePW?<ChangePassword onClose={closeChangePassword} username={user.userName}></ChangePassword>:null}
            {loaderVisible?<Dialog><Loader type={"infinite-spinner"}/></Dialog>:null}
            <TabStrip selected={tabSelected} onSelect={handleTabSelect} animation={false}>
                <TabStripTab title="User Profile" >   
                    {type=="Admin"?
                    <>
                        <Row className='mb-3'>
                            <Col xs="3"><Label className='mb-2'>*User Type:</Label></Col>
                            <Col xs="9"><DropDownList label="" value={userType} data={userTypes} dataItemKey='value' textField='text' fillMode={"outline"} onChange={userTypeChange}></DropDownList></Col>
                        </Row>
                        <Row className='mb-3'>
                            <Col xs="3"><Label className='mb-2'>*User Name:</Label></Col>
                            <Col xs="9">{action=="Edit"?<Input value={user.userName} onChange={setUserName} disabled={true} maxLength={50}></Input>:<Input value={user.userName} onChange={setUserName} maxLength={50}></Input>}</Col>
                        </Row>
                        <Row className='mb-3'>
                            <Col xs="3"><Label className='mb-2'>*Site:</Label></Col>
                            <Col xs="9"><SiteList setReturnAction={setSiteCodes} value={userSites} multi={true} valid={true} className='formField'/></Col>
                        </Row>
                        <Row className='mb-3'>
                            <Col xs="3"><Label className='mb-2'>{user.security==1 || user.security==2 ||user.security==4?"*Rep ID:":"Customer Name"}</Label></Col>
                            <Col xs="9"><Input value={user.customer} onChange={setRepID} maxLength={100}></Input></Col>
                        </Row>
                        {user.security==0?
                        <Row className='mb-3'>
                            <Col xs="3"><Label className='mb-2'>*Account:</Label></Col>
                            <Col xs="9"><Input value={user.temp2} onChange={setAccount} maxLength={13}></Input></Col>
                        </Row>
                        :null                        
                        }
                    </>:null}
                    <Row className='mb-3'>
                        <Col xs="3"><Label className='mb-2'>*Full Name:</Label></Col>
                        <Col xs="9"><Input value={user.fullName} onChange={setFullName} maxLength={100}></Input></Col>

                    </Row>
                    <Row className='mb-3'>
                        <Col xs="3"><Label className='mb-2'>*Email:</Label></Col>
                        <Col xs="9"><Input value={user.email} onChange={setEmail} maxLength={200}></Input></Col>
                    </Row>
                    <Row className='mb-3'>
                        <Col xs="3"><Label className='mb-2'>Phone:</Label></Col>
                        <Col xs="9"><Input value={user.phone} onChange={setPhone} maxLength={50}></Input></Col>
                    </Row>
                    <Row className='mt-3'>
                        <Col xs="3"><Label className='mb-2'>Alt Phone:</Label></Col>
                        <Col xs="9"><Input value={user.fax} onChange={setFax} maxLength={50}></Input></Col>
                    </Row>
                    <Row className='mt-3'>
                        {intAction=="Edit"?
                        <>
                        <Col xs="3"><Label className='mb-2'>Password:</Label></Col>
                        <Col xs="9"><Button onClick={openChangePassword}>Change Password</Button></Col>
                        </>
                        :null}
                    </Row>
                    <Row className='mt-3'>
                        <Col xs="3"><Label className='mb-2'>Email Pref:</Label></Col>
                        <Col xs="9"><DropDownList
                            fillMode={"outline"}
                            data={[
                                { text: "Do not send any automatic emails", value: "0" },
                                { text: "Send all emails automatically", value: "1" },
                                { text: "Only send proof emails automatically", value: "9" },
                                { text: "Only send material request emails automatically", value: "8" }
                            ]}
                            textField='text'
                            dataItemKey='value'
                            value ={emailOpt}
                            onChange={setEmailPref}
                        /></Col>
                    </Row>
                    {type=="Admin" && intAction=="Edit"?
                    <Row className='mt-3'>
                        <Col>
                            <Checkbox checked={getTrustedUser()} onChange={setTrustedUser}>&nbsp;Trusted User</Checkbox>                        
                        </Col>
                        {user.security==4?
                        <Col>
                            <Checkbox checked={getTrafficUser()} onChange={setTrafficUser}>&nbsp;Traffic User</Checkbox>
                        </Col>
                        :null}                        
                    </Row>:null}
                </TabStripTab>
                {type=="Admin" && intAction=="Edit"?
                    <TabStripTab title="Associations">
                        <Grid
                            data={associations}
                            dataItemKey='association'
                            selectable={{
                                enabled: true,
                                mode: 'single'
                            }}
                            onSelectionChange={onAssocSelectionChange}
                        >
                            <GridToolbar>
                                <Input onChange={updateIdToAssociate} value={idToAssociate} valid={assocValid}></Input><Button onClick={addAssociation}>Add New</Button><Button onClick={viewConfirmAssoc}>Remove Selected</Button>
                            </GridToolbar>
                            <GridColumn title='Association' field='association'></GridColumn>                           
                            <GridColumn title='Type' field='security' cells={{data:formatUserType}}></GridColumn>
                        </Grid>
                    </TabStripTab>
                :null}
                {type=="Admin" && intAction=="Edit" && user.temp3=="traffic"?
                <TabStripTab title="Traffic Groups" disabled={user.security==1 || user.security==2 || user.security==4?false:true}>
                    <Grid
                        data={groups}
                        dataItemKey='groupId'
                        selectable={{
                            enabled: true,
                            mode: 'single'
                        }}
                        onSelectionChange={onGroupSelectionChange}
                    >
                        <GridToolbar>
                            <RollUpGroupList setValue={onNewGroupChange} value={newGroup} valid={groupValid}></RollUpGroupList><Checkbox onChange={makePrimary}>&nbsp;Primary</Checkbox><Button onClick={addGroup}>Add New</Button><Button onClick={viewConfirmGroup}>Remove Selected</Button>
                        </GridToolbar>
                        <GridColumn title='Group ID' field='groupId'></GridColumn>     
                        <GridColumn title='Group Name' field='groupName'></GridColumn>                           
                        <GridColumn title='Primary' field='primary'></GridColumn>                           
                    </Grid>                
                </TabStripTab>
                :null}
            </TabStrip>
            <DialogActionsBar>
                <Button themeColor={"secondary"}onClick={hideContactInfo}>Close</Button>
                <Button themeColor={"primary"} onClick={callSaveUser}>Save</Button>
                {type=="Admin"?<Button themeColor={"warning"} onClick={callShowDelete}>Delete</Button>
:null}
            </DialogActionsBar>
        </Dialog>
    )
}